<template>
  <v-card class="d-flex align-center justify-center pa-5" style="background-color: rgba(0,0,0,0); min-height: 70vh;" outlined>
    <v-container fluid>
      <v-overlay absolute v-model="canIRegister" opacity="0.3"><TournamentRegisterCollapsed/></v-overlay>
      <v-row class="mt-2 mb-5" align="center" justify="center">
        <h2>{{ $t('title', { topItemsCount: rankingTopItems }) }}</h2>
        <v-icon class="ml-3" medium>fa-trophy</v-icon>
      </v-row>
      <!-- Current Winners !-->
      <v-row align="center" justify="center" class="my-7">
        <div class="mr-7" v-if="activeParticipants[1]">
          <div class="d-flex justify-center">
            <v-avatar class="glassy-parent" size="70" :style="`border: 3px solid #${$store.state.tournament.tournamentOrganizerColor} !important`">
              <v-img class="glassy-child"
                     :src="activeParticipants[1].profilePicture !== null? activeParticipants[1].profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'"/>
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-circle"/>
            </v-avatar>
          </div>
          <h4 class="text-center mt-2 mb-0">{{ $t('ranks.second') }}</h4>
          <p v-if="!$store.state.tournament.antiSpoiler" class="text-center mb-0">{{ username(activeParticipants[1]) }}</p>
        </div>
        <div v-if="activeParticipants[0]">
          <v-avatar class="glassy-parent" size="100" :style="`border: 3px solid #${$store.state.tournament.tournamentOrganizerColor} !important`">
            <v-img class="glassy-child"
                   :src="activeParticipants[0].profilePicture !== null? activeParticipants[0].profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'"/>
            <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-circle"/>
          </v-avatar>
          <h4 class="text-center mt-2 mb-0">{{ $t('ranks.first') }}</h4>
          <p v-if="!$store.state.tournament.antiSpoiler" class="text-center mb-0">{{ username(activeParticipants[0]) }}</p>
        </div>
        <div class="ml-7" v-if="activeParticipants[2]">
          <div class="d-flex justify-center">
            <v-avatar class="glassy-parent" size="70" :style="`border: 3px solid #${$store.state.tournament.tournamentOrganizerColor} !important`">
              <v-img class="glassy-child"
                  :src="activeParticipants[2].profilePicture !== null? activeParticipants[2].profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'"/>
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-circle"/>
            </v-avatar>
          </div>
          <h4 class="text-center mt-2 mb-0">{{ $t('ranks.third') }}</h4>
          <p v-if="!$store.state.tournament.antiSpoiler" class="text-center mb-0">{{ username(activeParticipants[2]) }}</p>
        </div>
      </v-row>
      <v-row align="center" justify="center">
        <v-data-table style="background-color: rgba(0,0,0,0); width: 100%" :items="activeParticipants" :headers="headers" :items-per-page="rankingTopItems" hide-default-footer>
          <template v-slot:item.rank="{ item }">
            <div class="d-flex align-center justify-start">
              <h4>{{ getRank(item) + 1 }}°</h4>
              <div v-if="item.previousPlace !== null && (getRank(item) + 1) !== item.previousPlace" class="d-flex align-center justify-start">
                <v-icon class="ml-2 mr-1" :color="(getRank(item) + 1 > item.previousPlace)? 'error' : 'primary'" x-small>
                  {{ (getRank(item) + 1 > item.previousPlace)? 'fa-caret-down' : 'fa-caret-up' }}</v-icon>
                <p :style="`color: ${(getRank(item) + 1 > item.previousPlace)? '#EF5350' : '#00a553'}`" class="my-0">{{ Math.abs((getRank(item) + 1) - item.previousPlace) }}</p>
              </div>
              <v-icon v-else-if="item.previousPlace !== null" class="ml-2" x-small>fa-grip-lines</v-icon>
            </div>
          </template>
          <template v-slot:item.image="{ item }">
            <div class="glassy-parent">
              <div class="glassy-child">
                <v-avatar size="35">
                  <v-img :src="item.profilePicture !== null? item.profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'"></v-img>
                </v-avatar>
                <Flag class="ml-n2 mb-n3" v-if="countryCode(item) !== null" :code="countryCode(item)" size="S"/>
              </div>
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-card"/>
            </div>
          </template>
          <template v-slot:item.firstName="{ item }">
            <div class="glassy-parent">
              <p class="glassy-child row-text" v-html="capitalize(item.firstName)"/>
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-card"/>
            </div>
          </template>
          <template v-slot:item.username="{ item }">
            <div class="glassy-parent">
              <p class="glassy-child row-text" v-html="username(item)"/>
              <div v-if="$store.state.tournament.antiSpoiler" class="glassy-child glassy-card"/>
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip :color="`#${$store.state.tournament.tournamentOrganizerColor}`" small outlined><p class="row-text">{{ capitalize(item.status) }}</p></v-chip>
          </template>
          <template v-slot:item.score="{ item }">
            <div v-if="$store.state.tournament.antiSpoiler" class="glassy-parent">
              <v-chip v-if="String($store.state.tournament.rankingType).includes('PERCENTAGE')" class="glassy-child" :color="`#${$store.state.tournament.tournamentOrganizerColor}`" text-color="white" small>
                <b>{{ (item.score != null)? `${(item.score * 100).toFixed(2)}%` : '-' }}</b>
              </v-chip>
              <v-chip v-else :color="`#${$store.state.tournament.tournamentOrganizerColor}`" class="glassy-child" text-color="white" small>
                <b>{{ (item.score != null)? item.score.toFixed(2) : '-' }}</b>
              </v-chip>
              <div class="glassy-child fit-glassy-card"/>
            </div>
            <div v-else>
              <v-chip v-if="String($store.state.tournament.rankingType).includes('PERCENTAGE')" :color="`#${$store.state.tournament.tournamentOrganizerColor}`" text-color="white" small>
                <b>{{ (item.score != null)? `${(item.score * 100).toFixed(2)}%` : '-' }}</b>
              </v-chip>
              <v-chip v-else :color="`#${$store.state.tournament.tournamentOrganizerColor}`" text-color="white" small>
                <b>{{ (item.score != null)? item.score.toFixed(2) : '-' }}</b>
              </v-chip>
              <v-chip v-if="$store.state.tournament.secondRankingType === null && isWinningByMainRank(item) !== 'None'" class="ml-2" color="secondary" small>
                <p class="row-text">{{ $t('table.winning') }} <b class="row-text">{{ isWinningByMainRank(item) }}</b></p>
                <v-icon color="green accent-3" class="ml-1" small>fa-medal</v-icon>
              </v-chip>
            </div>
          </template>
          <template v-slot:item.secondScore="{ item }">
            <v-chip v-if="item.score > $store.state.tournament.targetBalance" color="error" small><b>{{ (item.secondScore != null)? item.secondScore.toFixed(2) : '-' }}</b></v-chip>
            <v-chip v-if="isWinningBySecondRank(item) !== 'None'" color="secondary" class="ml-2" small>
              {{ $t('table.winning') }} <b class="ml-1">{{ isWinningBySecondRank(item) }}</b>
              <v-icon color="green accent-3" class="ml-1" small>fa-medal</v-icon>
            </v-chip>
          </template>
        </v-data-table>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import TournamentRegisterCollapsed from "@/views/Tournament/components/TournamentRegisterCollapsed";
import CountriesData from "@/views/Register/countries";

export default {
  name: "Leaderboard",
  components: {TournamentRegisterCollapsed},
  props: {
    tournament: Object,
    iAmParticipant: Boolean
  },
  data() {
    return {
      itStarted: false,
      canIRegister: false,
      rankingTopItems: 10,
      secondScoreRank: [],
      activeParticipants: [],
      countries: CountriesData,
      headers: [
        { text: 'Rank', align: 'left', value: 'rank', sortable: false },
        { text: 'Profile', align: 'left', value: 'image', sortable: false },
        { text: 'First Name', align: 'left', value: 'firstName', sortable: false },
        { text: 'Username', align: 'left', value: 'username', sortable: false },
        { text: 'Status', align: 'left', value: 'status', sortable: false },
      ],
    };
  },
  beforeCreate() {
    this.init();
    this.verifyCanIRegister();
  },
  mounted() {
    this.init();
    this.verifyCanIRegister();
  },
  watch: {
    '$store.state.tournament': function () {
      this.init();
      this.verifyCanIRegister();
    },
    iAmParticipant() {
      this.verifyCanIRegister();
    }
  },
  methods: {
    async init() {
      this.activeParticipants = await this.$store.state.tournament.participants.filter((participant) => participant.status === 'ACTIVE');
      this.verifyMockPositions();
      this.rankingTopItems = Math.max(10, this.$store.state.tournament.awards.length);
      let rankingHeader = this.$t(`table.rankTypes.${this.$store.state.tournament.rankingType}`);

      this.headers = [
        { text: this.$t('table.rank'), align: 'left', value: 'rank', sortable: false },
        { text: this.$t('table.profile'), align: 'left', value: 'image', sortable: false },
        { text: this.$t('table.firstName'), align: 'left', value: 'firstName', sortable: false },
        { text: this.$t('table.username'), align: 'left', value: 'username', sortable: false },
      ];
      this.headers.push({ text: rankingHeader, value: 'score', sortable: false });

      if(this.$store.state.tournament.tournamentOrganizerId === 54) // TODO Change after Impulse Tournament finished
        this.headers = this.headers.filter((item) => item.value !== 'firstName');

      if(this.$store.state.tournament.secondRankingType !== undefined && this.$store.state.tournament.secondRankingType !== null) {
        this.computeSecondRank();
        this.headers.push({ text: this.$t('table.second.GROSS_LOSS'), value: 'secondScore', sortable: false });
      }
    },
    verifyMockPositions() {
      let currentParticipants = this.$store.state.tournament.participants.length;
      if(this.$store.state.tournament.awards.length > currentParticipants) {
        let mockLength = this.$store.state.tournament.awards.length - currentParticipants;
        for(let i = 0; i < mockLength; i++)
          this.activeParticipants.push({
            profilePicture: null,
            firstName: '---',
            lastName: '---',
            username: '---',
            score: null,
            previousPlace: null,
          });
      }
    },
    verifyCanIRegister() {
      let startTime = new Date(this.$store.state.tournament.startTime);
      startTime.setDate(startTime.getDate()); // Condition to be added in db-model
      this.itStarted = startTime < new Date();
      let visibility = this.$store.state.tournament.tournamentVisibility;
      let isClubMember = this.$store.state.clubMember !== null && this.$store.state.tournament.tournamentOrganizerId === this.$store.state.clubMember.club.id;
      this.canIRegister = !this.itStarted && !this.iAmParticipant && (visibility === 'PUBLIC' || (visibility === 'PRIVATE' && isClubMember));
    },
    getRank(participant) {
      return this.activeParticipants.indexOf(participant);
    },
    computeSecondRank() {
      let participantsSortBySecondRank = this.activeParticipants.slice();
      participantsSortBySecondRank = participantsSortBySecondRank.filter((a) => a.secondScore !== null && a.score> this.$store.state.tournament.targetBalance);
      participantsSortBySecondRank.sort((a, b) => (a.secondScore < b.secondScore)? 1 : (a.secondScore > b.secondScore) ? -1 : 0);

      participantsSortBySecondRank.forEach((participant) => {
        this.secondScoreRank.push(participant.participantId);
      });
    },
    isWinningByMainRank(participant) {
      let foundAward = this.$store.state.tournament.awards.find((award) => award.rank === (this.getRank(participant) + 1));
      return (foundAward !== undefined)? foundAward.title : 'None';
    },
    isWinningBySecondRank(participant) {
      let winning = 'None';
      this.$store.state.tournament.awards.forEach((award) => {
        if(participant.participantId === this.secondScoreRank[award.rank - 1])
          winning = award.title;
      });
      return winning;
    },
    countryCode(participant) {
      let countryFound = this.countries.find((country) => country.name === participant.country );
      return (countryFound !== undefined)? countryFound.code : null;
    },
    username(participant) {
      let usernameSplit = String(participant.username).split('@');
      return usernameSplit[0];
    },
    veryFirstName(participant) {
      return this.capitalize(String(participant.firstName).split(' ')[0]);
    },
    capitalize(string) {
      let arr = string.split(" ");
      for (let i = 0; i < arr.length; i++)
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
      return arr.join(" ");
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/global";

.avatar-special {
  border: 3px solid #00a553 !important;
}

.row-text {
  font-size: 14px !important;
  margin-bottom: 0;
}

.flag-text {
  z-index: 100!important;
  font-size: 14px !important;
  margin-bottom: -5px;
  margin-top: -10px;
  margin-left: 30px;
}

.glassy-parent {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}

.glassy-child{
  position: absolute;
}

.glassy-card {
  z-index: 2;
  top: 0;
  left: 0;
  width: 125%;
  height: 100%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(2.8px);
  -webkit-backdrop-filter: blur(2.8px);
}

.fit-glassy-card {
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(2.8px);
  -webkit-backdrop-filter: blur(2.8px);
}

.glassy-circle {
  border-radius: 100px 100px 100px 100px !important;
  z-index: 2;
  top: 0;
  left: 0;
  width: 140%;
  height: 100%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(2.8px);
  -webkit-backdrop-filter: blur(2.8px);
}
</style>

<i18n>
{
  "en": {
    "title": "Current Top-{topItemsCount}",
    "ranks": {
      "first": "1st",
      "second": "2nd",
      "third": "3rd"
    },
    "table": {
      "rank": "Rank",
      "profile": "Profile",
      "firstName": "First Name",
      "username": "Username",
      "status": "Status",
      "rankTypes": {
        "SWISET_RATIO": "Swiset Ratio",
        "BALANCE": "Balance",
        "PERFORMANCE_RATIO": "Performance Ratio",
        "PROFIT_PERCENTAGE": "% Profit",
        "EQUITY_RT": "Equity"
      },
      "second": {
        "GROSS_LOSS": "Gross Loss"
      },
      "winning": "Winning"
    }
  },
  "es": {
    "title": "Actual Top-{topItemsCount}",
    "ranks": {
      "first": "1ro",
      "second": "2do",
      "third": "3ro"
    },
    "table": {
      "rank": "Posición",
      "profile": "Perfil",
      "firstName": "Nombre",
      "username": "Usuario",
      "status": "Estado",
      "rankTypes": {
        "SWISET_RATIO": "Ratio Swiset",
        "BALANCE": "Balance",
        "PERFORMANCE_RATIO": "Ratio Rendimiento",
        "PROFIT_PERCENTAGE": "% Retorno",
        "EQUITY_RT": "Equidad"
      },
      "second": {
        "GROSS_LOSS": "Pérdida Neta"
      },
      "winning": "Ganando"
    }
  }
}
</i18n>
